var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-callout",class:{'is-inline': _vm.inline}},[_c('div',{staticClass:"c-callout__content",domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }